import DialogContent from '@mui/material/DialogContent';
import { AlertDialog } from 'components/dialog';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';

interface DeleteHardSkillModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteHardSkillModal({
  isOpen,
  onClose,
  onConfirm
}: DeleteHardSkillModalProps) {
  return (
    <AlertDialog
      isOpen={isOpen}
      title={getTrans('modal.deleteHardSkill.title')}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmLabel={getTrans('general.delete')}
      cancelLabel={getTrans('modal.button.cancel')}
      confirmColor="error"
    >
      <DialogContent
        sx={{ color: 'text.primary', textAlign: 'center', fontSize: '13px' }}
      >
        <Text variant="body2">{getTrans('modal.deleteHardSkill.body')}</Text>
      </DialogContent>
    </AlertDialog>
  );
}
